import { GenericResponse } from 'services/api/base';
import {
  SemanalVisaoGeral,
  SemanalChuva,
  SemanalCarga,
  SemanalResultados,
  SemanalPremissas,
} from 'types/Relatorios/Semanal';

export const transformSemanalVisaoGeralResponse = (
  response: GenericResponse<SemanalVisaoGeral>,
): SemanalVisaoGeral => response.data;

export const transformSemanalChuvaResponse = (
  response: GenericResponse<SemanalChuva>,
): SemanalChuva => response.data;

export const transformSemanalCargaResponse = (
  response: GenericResponse<SemanalCarga>,
): SemanalCarga => response.data;

export const transformSemanalResultadosResponse = (
  response: GenericResponse<SemanalResultados>,
): SemanalResultados => response.data;

export const transformSemanalPremissasResponse = (
  response: GenericResponse<SemanalPremissas>,
): SemanalPremissas => response.data;
